import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
